export default "__VITE_PUBLIC_ASSET__d9b07937__"